// extracted by mini-css-extract-plugin
export default {"cls1":"SmallAccountMenuButton-cls1_Ill","cls2":"SmallAccountMenuButton-cls2__p9 SmallAccountMenuButton-cls1_Ill"};